<template>
  <div class="page-container" style="width:99%;margin-top:15px;">
    <el-carousel :interval="3000" type="card" height="800px" class="carousel">
      <el-carousel-item class="carousel-item-intro">
        <h2>接口调用</h2>
        <ul>
            <li>✔ SciEngine在线上传成功后，触发调用接口通知DDS平台进行单篇转换</li>
            <li>✔ SciEngine整期发布成功后，触发调用接口通知DDS平台进行整期转换（Pubmed）</li>
        </ul>
        <h2>功能计划</h2>
        <ul>
          <li>✔ 系统登录：系统用户登录，系统登录认证（token方式）</li>
          <li>✔ 用户管理：新建用户，修改用户，删除用户，查询用户</li>
          <li>✔ 机构管理：新建机构，修改机构，删除机构，查询机构</li>
          <li>✔ 期刊管理：新建期刊，修改期刊，删除期刊，查询期刊</li>
          <li>✔ FTP管理：新建FTP，修改FTP，删除FTP，查询FTP</li>
          <li>✔ 邮箱管理：新建邮箱，修改邮箱，删除邮箱，查询邮箱</li>
          <li>✔ 出版类型管理：新建出版类型，修改出版类型，删除及查询</li>
          <li>✔ 转换方法管理：新建、修改、删除及查询转换方法</li>
          <li>✔ 结果查询：分类查询转换结果</li>
        </ul>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    components:{
    },
    methods :{
    }
  }
</script>

<style scoped>
  .carousel {
    padding-left: 20px;
    padding-right: 20px;
    margin-right: 20px;
  }
  .carousel h2 {
    color: #475669;
    font-size: 22px;
    opacity: 1.75;
    line-height: 100px;
    margin: 0;
  }
  .carousel .el-carousel__item {
    padding: 0 20px;
  }
  .carousel ul {
    color: #475669;
    font-size: 15px;
    opacity: 1.75;
    line-height: 40px;
    margin: 0;
  }
  .carousel ul li {
    list-style-type: none;
  }
  .carousel-item-intro h2 {
    color: #ffffff;
    font-size: 22px;
    opacity: 1;
    line-height: 65px;
    margin: 0;
  }
  .carousel-item-intro ul {
    color: #ffffff;
    font-size: 15px;
    opacity: 1;
    line-height: 50px;
    padding: 5px;
    margin: 0;
  }
  .carousel-item-intro {
    background-color: #19aaaf73;
    -webkit-border-radius: 25px;
    border-radius: 25px;
    -moz-border-radius: 15px;
    background-clip: padding-box;
    box-shadow: 0 0 25px #a3b3b965;
  }
  .carousel-item-intro {
    background-color: #475669;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Intro/Intro.vue